import React, { useState, useEffect } from "react";
import BackBtn from "../../btncomponent/BackBtn";
import { isAuthenticated } from "../../auth";
import Swal from "sweetalert2";

const Addroom = () => {
  const [cities, setCities] = useState([]);

  const [values, setValues] = useState({
    description: "",
    price: "",
    categories: [],
    category: "",
    city: "",
    distance: "",
    kitchen: "",
    bathroom: "",
    bedroom: "",
    map: "",
    photo: "",
    loading: false,
    error: "",
    formData: "",
    createProduct: "",
  });

  const {
    name,
    description,
    price,
    categories,

    distance,
    kitchen,
    bathroom,
    bedroom,
    map,
    loading,
    error,
    formData,
    createProduct,
  } = values;

  const { user, token } = isAuthenticated();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/category`, {
      method: "GET",
    })
      .then((res) => {
        return res.json();
      })
      .catch((err) => {
        console.log(err);
      })
      .then((data) => {
        if (data.error) {
          setValues({ error: data.error });
        } else {
          setValues({ categories: data, formData: new FormData() });
        }
      });

    fetch(`${process.env.REACT_APP_API_URL}/city`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setCities(data);
      });
  }, []);

  const handleChange = (name) => (event) => {
    const value = name === "photo" ? event.target.files[0] : event.target.value;
    formData.set(name, value);
    setValues({ ...values, [name]: value, error: "" });
  };

  const clickSubmit = (e) => {
    setValues({ ...values, loading: true });
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_URL}/home/create/${user._id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .catch((err) => {
        console.log(err);
      })
      .then((data) => {
        if (data.error) {
          setValues({ ...values, error: data.error });
        } else {
          Swal.fire({
            title: " New Room Added successfully",
          });

          setValues({
            ...values,
            name: "",
            description: "",
            price: "",
            distance: "",
            kitchen: "",
            category: "",
            bathroom: "",
            bedroom: "",
            map: "",
            loading: false,
            createProduct: data.name,
          });
        }
      });
  };

  const showError = () => (
    <div style={{ display: error ? "" : "none" }}>
      <div
        className="alert alert-danger alert-dismissible fade show"
        role="alert"
      >
        {error}
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  );

  const showSuccess = () => (
    <div style={{ display: createProduct ? "" : "none" }}>
      <div
        className="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        New Room Added successfully
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  );

  const showLoading = () =>
    loading && (
      <div className="alert alert-success">
        <h2>Loading...</h2>
      </div>
    );

  return (
    <div className="container mt-3">
      <BackBtn location="/admin/dashboard" />

      <h2 className="text-muted mt-3 mb-3">Add New Room</h2>
      {showLoading()}
      {showSuccess()}
      {showError()}
      <form onSubmit={clickSubmit} className="mb-3">
        <label className="text-muted">Add Photo</label>
        <div className="form-group">
          <label className="btn btn-secondary">
            <input
              onChange={handleChange("photo")}
              type="file"
              name="photo"
              accept="image/*"
            />
          </label>
        </div>

        <div className="form-group">
          <label className="text-muted">Name</label>
          <input
            value={name}
            onChange={handleChange("name")}
            type="text"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Description</label>
          <textarea
            value={description}
            onChange={handleChange("description")}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Price</label>
          <input
            onChange={handleChange("price")}
            value={price}
            type="number"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Distance</label>
          <input
            onChange={handleChange("distance")}
            value={distance}
            type="text"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Area</label>
          <select onChange={handleChange("category")} className="form-select">
            <option>Please select</option>
            {categories &&
              categories.map((c, i) => (
                <option key={i} value={c._id}>
                  {c.name}
                </option>
              ))}
          </select>
        </div>

        <div className="form-group">
          <label className="text-muted">City</label>
          <select onChange={handleChange("city")} className="form-select">
            <option>Please select</option>
            {cities &&
              cities.map((c, i) => (
                <option key={i} value={c._id}>
                  {c.name}
                </option>
              ))}
          </select>
        </div>

        <div className="form-group">
          <label className="text-muted">Kitchen</label>
          <input
            onChange={handleChange("kitchen")}
            value={kitchen}
            type="text"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Bathroom</label>
          <input
            onChange={handleChange("bathroom")}
            value={bathroom}
            type="text"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Bedroom</label>
          <input
            onChange={handleChange("bedroom")}
            value={bedroom}
            type="text"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Map</label>
          <input
            onChange={handleChange("map")}
            value={map}
            type="text"
            className="form-control"
          />
        </div>

        <button className="btn btn-outline-primary mt-2">Add Room</button>
      </form>
    </div>
  );
};

export default Addroom;
